import { CommonModule, NgClass } from '@angular/common';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

import { AccountPageService } from '../user-account/services/account-page.service';
import { AppMaterialModule } from './material.module';
import { AttributeDirective } from 'src/app/infrastructure/directives/attribute.directive';
import { BadgeComponent } from './badge/badge.component';
import { DomainPageService } from '../domain/services/domain-page.service';
import { FileUploadComponent } from '../image/components/file-upload/file-upload.component';
import { FilterPipe } from 'src/app/infrastructure/pipes/filter.pipe';
import { IconsModule } from './icons/icons.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NotificationComponent } from './notification/notification.component';
import { SelectAutofocusDirective } from 'src/app/infrastructure/directives/select-autofocus-directive';
import { SrcFilePipe } from 'src/app/infrastructure/pipes/src-file.pipe';
import { UrlPipeUnique } from 'src/app/infrastructure/pipes/url-unique.pipe';
import { VisibleWhenClaimDirective } from 'src/app/infrastructure/directives/auth-control.directive';

@NgModule({
    imports: [
        AppMaterialModule,
        AttributeDirective,
        BadgeComponent,
        CommonModule,
        FileUploadComponent,
        FilterPipe,
        FontAwesomeModule,
        FormsModule,
        IconsModule,
        NgClass,
        NotificationComponent,
        ReactiveFormsModule,
        RouterModule,
        SelectAutofocusDirective,
        SrcFilePipe,
        UrlPipeUnique,
        VisibleWhenClaimDirective
],
    providers: [
        AccountPageService,
        DomainPageService,
    ],
    exports: [
        AppMaterialModule,
        AttributeDirective,
        BadgeComponent,
        CommonModule,
        FileUploadComponent,
        FilterPipe,
        FontAwesomeModule,
        FormsModule,
        IconsModule,
        NgClass,
        NgxPaginationModule,
        NotificationComponent,
        ReactiveFormsModule,
        RouterModule,
        SelectAutofocusDirective,
        SrcFilePipe,
        UrlPipeUnique,
        VisibleWhenClaimDirective,
    ]
})
export class SharedModule {
    constructor(library: FaIconLibrary) {
      library.addIconPacks(fas, far);
    }
}
